module.exports = __webpack_public_path__ + "static/img/6areaA_2.7ffd31c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/6areaA_2.png
// module id = 917
// module chunks = 1